import {
    List, Datagrid, TextField, DateField,
    Edit, SimpleForm, Create, SelectInput,
    ReferenceInput, ReferenceField,
    useRecordContext, TopToolbar, ListButton,
} from 'react-admin';
import { Chip } from '@mui/material';

const PrerequisiteTypeField = () => {
    const record = useRecordContext();
    if (!record) return null;

    const isHard = record.type === 'hard';

    return (
        <Chip
            label={isHard ? 'Pflicht (blockiert)' : 'Empfohlen (Warnung)'}
            color={isHard ? 'error' : 'warning'}
            size="small"
        />
    );
};

export const CoursePrerequisiteList = () => (
    <List>
        <Datagrid rowClick="edit">
            <ReferenceField source="course" reference="courses" label="Kurs">
                <TextField source="title" />
            </ReferenceField>
            <ReferenceField source="prerequisiteCourse" reference="courses" label="Voraussetzung">
                <TextField source="title" />
            </ReferenceField>
            <PrerequisiteTypeField />
            <DateField source="createdAt" label="Erstellt" />
        </Datagrid>
    </List>
);

export const CoursePrerequisiteEdit = () => (
    <Edit actions={<TopToolbar><ListButton /></TopToolbar>}>
        <SimpleForm>
            <ReferenceInput source="course" reference="courses" label="Kurs" sort={{ field: 'title', order: 'ASC' }}>
                <SelectInput optionText="title" fullWidth />
            </ReferenceInput>

            <ReferenceInput source="prerequisiteCourse" reference="courses" label="Voraussetzung (muss abgeschlossen sein)" sort={{ field: 'title', order: 'ASC' }}>
                <SelectInput optionText="title" fullWidth />
            </ReferenceInput>

            <SelectInput
                source="type"
                label="Typ"
                choices={[
                    { id: 'hard', name: 'Pflicht - blockiert Einschreibung' },
                    { id: 'soft', name: 'Empfohlen - zeigt Warnung' },
                ]}
                fullWidth
                helperText="'Pflicht' blockiert die Einschreibung, 'Empfohlen' zeigt nur eine Warnung"
            />
        </SimpleForm>
    </Edit>
);

export const CoursePrerequisiteCreate = () => (
    <Create actions={<TopToolbar><ListButton /></TopToolbar>}>
        <SimpleForm>
            <ReferenceInput source="course" reference="courses" label="Kurs" sort={{ field: 'title', order: 'ASC' }}>
                <SelectInput optionText="title" fullWidth />
            </ReferenceInput>

            <ReferenceInput source="prerequisiteCourse" reference="courses" label="Voraussetzung (muss abgeschlossen sein)" sort={{ field: 'title', order: 'ASC' }}>
                <SelectInput optionText="title" fullWidth />
            </ReferenceInput>

            <SelectInput
                source="type"
                label="Typ"
                choices={[
                    { id: 'hard', name: 'Pflicht - blockiert Einschreibung' },
                    { id: 'soft', name: 'Empfohlen - zeigt Warnung' },
                ]}
                defaultValue="soft"
                fullWidth
                helperText="'Pflicht' blockiert die Einschreibung, 'Empfohlen' zeigt nur eine Warnung"
            />
        </SimpleForm>
    </Create>
);
